import { styled } from '@mui/material/styles';

const PrettyLink = styled('a')(({ theme }) => ({
  textDecoration: 'none',
    color: '#ffffff',
    "&:hover": {
      color: "#82D2EE",
      textDecoration: 'underline'
    },
}));

export default PrettyLink;